import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const AdminFilters = ({ filters, setFilters }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between" data-testid="admin-filters">
      <Tabs value={filters.status} onValueChange={set("status")}>
        <TabsList className="bg-[#121216]">
          <TabsTrigger value="all" data-testid="admin-filter-all">All</TabsTrigger>
          <TabsTrigger value="confirmed" data-testid="admin-filter-confirmed">Confirmed</TabsTrigger>
          <TabsTrigger value="cancelled" data-testid="admin-filter-cancelled">Cancelled</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
          <Input placeholder="Search name, email, notes" value={filters.q} onChange={(e) => set("q")(e.target.value)} className="pl-9 sm:w-64" data-testid="admin-search-input" />
        </div>
        <div className="flex items-center gap-2">
          <Input type="date" value={filters.date} onChange={(e) => set("date")(e.target.value)} className="sm:w-44 [color-scheme:dark]" data-testid="admin-date-filter" />
          {filters.date && (
            <button onClick={() => set("date")("")} className="text-zinc-500 hover:text-white" data-testid="admin-date-clear" aria-label="Clear date">
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
